import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetDashboardMovesMapQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  customerId: Types.Scalars['bigint']['input'];
  additionalFilters?: Types.InputMaybe<Array<Types.Moves_Bool_Exp> | Types.Moves_Bool_Exp>;
  limit: Types.Scalars['Int']['input'];
}>;


export type GetDashboardMovesMapQuery = { __typename?: 'query_root', moves: Array<{ __typename?: 'moves', id: number, status?: string | null, move_type: string, driver_id?: number | null, driver_name?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_year?: string | null, vehicle_color?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, pickup_time?: string | null, delivery_time?: string | null, pickup_started?: string | null, pickup_successful?: string | null, delivery_started?: string | null, delivery_successful?: string | null, reference_num?: string | null, consumer_name?: string | null, scenariotomoves: Array<{ __typename?: 'scenariotomoves', scenario: { __typename?: 'scenarios', id: number, scenario_key: string, status: string } }>, delivery_photos: Array<{ __typename?: 'vehiclephotos', id: string, step_id: string, url?: string | null }>, pickup_photos: Array<{ __typename?: 'vehiclephotos', id: string, step_id: string, url?: string | null }>, lane?: { __typename?: 'lanes', id: number, distance_miles?: number | null, route_polyline?: string | null, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, geofence_radius?: number | null, geofence_vertices?: object | null, geofence_center_lat?: number | null, geofence_center_lng?: number | null }, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, geofence_radius?: number | null, geofence_vertices?: object | null, geofence_center_lat?: number | null, geofence_center_lng?: number | null } } | null, driver?: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null, phone?: string | null, email?: string | null } | null, gpslocations: Array<{ __typename?: 'driverlocations', id: string, location: object, time: string, speed?: number | null, heading?: number | null, is_moving: boolean, battery_level?: number | null, battery_is_charging: boolean }> } | null }> };


export const GetDashboardMovesMapDocument = gql`
    query getDashboardMovesMap($start: timestamptz!, $end: timestamptz!, $customerId: bigint!, $additionalFilters: [moves_bool_exp!], $limit: Int!) {
  moves(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}, {_and: $additionalFilters}]}
    order_by: {pickup_time: asc}
    limit: $limit
  ) {
    id
    status
    move_type
    driver_id
    driver_name
    vehicle_make
    vehicle_model
    vehicle_year
    vehicle_color
    vehicle_stock
    vehicle_vin
    pickup_time
    delivery_time
    pickup_started
    pickup_successful
    delivery_started
    delivery_successful
    reference_num
    consumer_name
    scenariotomoves(where: {scenario: {status: {_neq: "deprecated"}}}) {
      scenario {
        id
        scenario_key
        status
      }
    }
    delivery_photos: vehiclephotos(where: {workflow: {type: {_eq: "delivery"}}}) {
      id
      step_id
      url
    }
    pickup_photos: vehiclephotos(where: {workflow: {type: {_eq: "pickup"}}}) {
      id
      step_id
      url
    }
    lane {
      id
      distance_miles
      route_polyline
      pickup {
        id
        name
        address
        latitude
        longitude
        geofence_radius
        geofence_vertices
        geofence_center_lat
        geofence_center_lng
      }
      delivery {
        id
        name
        address
        latitude
        longitude
        geofence_radius
        geofence_vertices
        geofence_center_lat
        geofence_center_lng
      }
    }
    driver {
      id
      status
      user {
        id
        display_name
        avatar_url
        phone
        email
      }
      gpslocations(order_by: {time: desc}, limit: 1) {
        id
        location
        time
        speed
        heading
        is_moving
        battery_level
        battery_is_charging
      }
    }
  }
}
    `;

/**
 * __useGetDashboardMovesMapQuery__
 *
 * To run a query within a React component, call `useGetDashboardMovesMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardMovesMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardMovesMapQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      customerId: // value for 'customerId'
 *      additionalFilters: // value for 'additionalFilters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDashboardMovesMapQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardMovesMapQuery, GetDashboardMovesMapQueryVariables> & ({ variables: GetDashboardMovesMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardMovesMapQuery, GetDashboardMovesMapQueryVariables>(GetDashboardMovesMapDocument, options);
      }
export function useGetDashboardMovesMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardMovesMapQuery, GetDashboardMovesMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardMovesMapQuery, GetDashboardMovesMapQueryVariables>(GetDashboardMovesMapDocument, options);
        }
// @ts-ignore
export function useGetDashboardMovesMapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardMovesMapQuery, GetDashboardMovesMapQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardMovesMapQuery, GetDashboardMovesMapQueryVariables>;
export function useGetDashboardMovesMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardMovesMapQuery, GetDashboardMovesMapQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardMovesMapQuery | undefined, GetDashboardMovesMapQueryVariables>;
export function useGetDashboardMovesMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardMovesMapQuery, GetDashboardMovesMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardMovesMapQuery, GetDashboardMovesMapQueryVariables>(GetDashboardMovesMapDocument, options);
        }
export type GetDashboardMovesMapQueryHookResult = ReturnType<typeof useGetDashboardMovesMapQuery>;
export type GetDashboardMovesMapLazyQueryHookResult = ReturnType<typeof useGetDashboardMovesMapLazyQuery>;
export type GetDashboardMovesMapSuspenseQueryHookResult = ReturnType<typeof useGetDashboardMovesMapSuspenseQuery>;
export type GetDashboardMovesMapQueryResult = Apollo.QueryResult<GetDashboardMovesMapQuery, GetDashboardMovesMapQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/queries/getDashboardMovesMap.query.gql}
 */
export async function getDashboardMovesMap(
  variables: GetDashboardMovesMapQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDashboardMovesMapQuery['moves']>
export async function getDashboardMovesMap(
  variables: GetDashboardMovesMapQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDashboardMovesMapQuery>
export async function getDashboardMovesMap(
  variables: GetDashboardMovesMapQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDashboardMovesMapQuery['moves'] | GetDashboardMovesMapQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDashboardMovesMapQuery>(
    GetDashboardMovesMapDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves
}